export const brandShort = import.meta.env.VITE_APP_BRAND
export const brandLong = import.meta.env.VITE_APP_BRAND_LONG
export const buildMode = import.meta.env.MODE
export const isDevBuild = import.meta.env.MODE === 'development'
export const isDevEnv = isDevBuild
export const isStagingEnv = import.meta.env.MODE === 'staging'
export const isTrainingEnv = import.meta.env.MODE === 'training'
export const isDemoEnv = import.meta.env.MODE === 'demo'

export const baseUrl = import.meta.env.BASE_URL
const apiUrlLocalStorage = localStorage.getItem('apiUrl')
const apiUrlEnv = import.meta.env.VITE_API_URL || '/api/v2'

const apiUrlRaw =
  /* Recover apiUrl from localStorage only in dev and staging env */
  (isDevEnv || isStagingEnv) && apiUrlLocalStorage
    ? apiUrlLocalStorage
    : apiUrlEnv

// Absolute URL required for URL constructor resolution — if relative, API must share origin with UI.
// Cross-origin dev: localStorage.setItem('apiUrl', 'http://localhost:8000/api/v2')
export const apiUrl = new URL(apiUrlRaw, window.location.origin).href

export const modelMetaCacheTTL =
  isDevEnv || isStagingEnv
    ? 10 * 60 * 1000 /* 10 minutes */
    : 60 * 60 * 1000 /* 1 hour */

export const adminUrl = import.meta.env.VITE_ADMIN_URL || '/admin'

const S3 = 'https://s3.embl.de/gbcs-public/labid-ui'
export const brandLogoWhiteUrl =
  import.meta.env.VITE_BRAND_LOGO_WHITE_URL || `${S3}/labid-notext-white.png`
export const brandLogoBlackUrl =
  import.meta.env.VITE_BRAND_LOGO_BLACK_URL || `${S3}/labid-notext-black.png`
export const brandLogoBlueUrl =
  import.meta.env.VITE_BRAND_LOGO_BLUE_URL || `${S3}/labid-notext-blue.png`
export const brandLogoBigBlackUrl =
  import.meta.env.VITE_BRAND_LOGO_BIG_BLACK_URL || `${S3}/labid-big-black.png`
export const brandLogoSmallBlackUrl =
  import.meta.env.VITE_BRAND_LOGO_SMALL_BLACK_URL || `${S3}/labid-black.png`
export const appRepo = import.meta.env.VITE_APP_REPO
export const uiCommitHash = import.meta.env.VITE_COMMIT_HASH
export const uiCommitBranch = import.meta.env.VITE_BRANCH_NAME
export const demoAppUrl = import.meta.env.VITE_DEMO_URL
export const projectDocs = import.meta.env.VITE_PROJECT_DOCS || '/docs'
export const projectHomepage = import.meta.env.VITE_PROJECT_HOMEPAGE || ''
export const projectIssues = import.meta.env.VITE_PROJECT_ISSUES
export const projectLinkedin = import.meta.env.VITE_PROJECT_LINKEDIN
export const projectRepo = import.meta.env.VITE_PROJECT_REPO
export const projectEmail = import.meta.env.VITE_PROJECT_EMAIL || ''
export const projectMaintainers = import.meta.env.VITE_PROJECT_MAINTAINERS || ''
export const projectChat = import.meta.env.VITE_PROJECT_CHAT || ''
export const dmappUrl = import.meta.env.VITE_DMAPP_URL || ''
export const institutionNameShort =
  import.meta.env.VITE_INSTITUTION_NAME_SHORT || ''
export const institutionNameLong =
  import.meta.env.VITE_INSTITUTION_NAME_LONG || ''

export const enableSentry = import.meta.env.VITE_ENABLE_SENTRY === 'true'
export const sentryDsn = import.meta.env.VITE_SENTRY_DSN
export const sentryUrl = import.meta.env.VITE_SENTRY_URL

const demoUser = import.meta.env.VITE_DEMO_USER
export const testUser = demoUser && demoUser.toLowerCase()
export const testPassword = import.meta.env.VITE_DEMO_PASSWORD

// These should eventually be obtained by querying the API @ `/config`
export const importItemsLimit = 1000

if (!isDevBuild && !import.meta.env.VITE_DEPLOYMENT_URL) {
  console.warn(
    '[app.config] VITE_DEPLOYMENT_URL is not set — canonical URL, og:url, and JSON-LD url will be empty. Set this in your deployment .env.',
  )
}
